/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_particle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Particle size`)
};

const es_hplc_particle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de partícula`)
};

const de_hplc_particle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partikelgröße`)
};

const nl_hplc_particle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deeltjesgrootte`)
};

const fr_hplc_particle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille des particules`)
};

const it_hplc_particle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione particelle`)
};

const pt_br2_hplc_particle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho de partícula`)
};

const pt_hplc_particle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da partícula`)
};

const ja_hplc_particle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粒子径`)
};

const zh_hplc_particle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粒径`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_particle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_particle(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_particle", locale)
	if (locale === "en") return en_hplc_particle(inputs)
	if (locale === "es") return es_hplc_particle(inputs)
	if (locale === "de") return de_hplc_particle(inputs)
	if (locale === "nl") return nl_hplc_particle(inputs)
	if (locale === "fr") return fr_hplc_particle(inputs)
	if (locale === "it") return it_hplc_particle(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_particle(inputs)
	if (locale === "pt") return pt_hplc_particle(inputs)
	if (locale === "ja") return ja_hplc_particle(inputs)
	return zh_hplc_particle(inputs)
};